export const stats = {
  general: {
    block: {
      main: 'Calls',
      acd: 'ACD',
      asr: 'ASR'
    },

    filter: {
      group_by: {
        title: 'Kelompok',
        values: {
          day: 'Hari',
          month: 'Bulan',
          country: 'Negara'
        }
      },

      type: {
        title: 'Jenis',
        values: {
          outgoing: 'Outgoing',
          incoming: 'Incoming'
        }
      },
      source: {
        title: 'Sumber data'
      },

      destination: {
        title: 'Tujuan'
      },

      voice_stats: {
        trunk: {
          title: 'Belalai'
        },
        destination_b_number: {
          title: 'Tujuan (B-number)'
        },
        source: {
          title: 'Original A-number'
        },
        destination: {
          title: 'Negara'
        }
      }
    },

    field: {
      group: 'Kelompok',
      total: 'Total',
      asr: 'ASR',
      acd: 'ACD',
      duration: 'Durasi',
      duration_billed: 'Durasi dipanggang',
      cost: 'Biaya'
    }
  },

  detailed: {
    field: {
      country: 'Negara',
      source_incoming: 'Original A-number',
      source_outgoing: 'Substituted A-number',
      destination: 'Tujuan (B-number)',
      duration: 'Durasi',
      duration_billed: 'Durasi dipanggang',
      cost: 'Biaya',
      date: 'Tanggal',
      call_type: 'Jenis Panggilan',
      audio: 'Audio'
    }
  }
};
